import React from 'react'
import { Provider } from 'react-redux'
import createHistory from 'history/createBrowserHistory'
import { ConnectedRouter, routerMiddleware } from 'react-router-redux'
import { NotificationsManager } from 'advenio-components'
import { Api } from 'auth-advenio'

import AuthContainer from './AuthContainer'
import './Styles/App.css'

import createStore from '../Data/Redux'

// Create a browser history
const history = createHistory()

// Build the middleware for intercepting and dispatching navigation actions
const historyMiddleware = routerMiddleware(history)

// Create our store, with middlewares
const store = createStore([historyMiddleware])
Api.setStore(store)

const App = () => (
  <Provider store={store}>
    { /* ConnectedRouter will use the store from Provider automatically */ }
    <div>
      <ConnectedRouter history={history}>
        <AuthContainer />
      </ConnectedRouter>
      <NotificationsManager />
    </div>
  </Provider>
)

export default App



// WEBPACK FOOTER //
// ./src/Containers/App.jsx